import { OBTIENE_ENCUESTAS } from "../actions/types";

const INITIAL_STATE = [];

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case OBTIENE_ENCUESTAS:
            //console.log("Respuesta Reducer", action);
            return [...action.payload.Result];
        default:
            return state;
    }
};
